import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
  
import { MenuReducer as menuReducer } from './menu.reducer';
import { ProfileReducer as profileReducer } from './profile.reducer';
import { SidebarReducer as sidebarReducer } from './sidebar.reducer';
import { ToolbarReducer as toolbarReducer } from './toolbar.reducer';


import { IProfileState } from './../interfaces/profile';
import { IAppState } from './../interfaces/state';


export const selectProfile = createFeatureSelector< IProfileState>(
  'profile'
);

export const selectAuthState = createSelector(
  selectProfile,
  state => state.authorized
);

export const selectSidebar = createFeatureSelector<any>(
  'sidebar'
);

export const selectToggleSidebar = createSelector(
  selectSidebar,
  state => state.toggle
);

export const selectToolbar = createFeatureSelector<any>(
  'toolbar'
);

export const selectToolbarUserType = createSelector(
  selectToolbar,
  state => state.userType
);

export const selectMenu = (state: IAppState) => state.menu;

export const reducers: ActionReducerMap<IAppState> = {
  sidebar: sidebarReducer,
  profile: profileReducer,
  menu: menuReducer,
  toolbar: toolbarReducer
};
  